import * as yup from "yup";

export interface IValuesLogin {
  password: string | null;
  email: string | null;
}

export const initialValues: IValuesLogin = {
  password: "",
  email: ""
};

export const formValidations = yup.object({
  password: yup
    .string()
    .nullable()
    .required("El campo contraseña es requerido"),
  email: yup
    .string()
    .email("El correo no válido")
    .nullable()
    .required("El campo correo es requerido")
});
